"use client";
import AppLayout from "@/components/app/applayout";
import SocialContact from "@/components/consultation/contact";
import Header from "@/components/consultation/header";
import Next from "@/components/consultation/next";
import InputForm from "@/components/consultation/inputForms";
import { AppSize, pxToRem } from "@/util";
import { Box } from "@mui/material";
// import Image from "next/image";
import React from "react";
import { makeStyles } from "tss-react/mui";

export default function Consultation() {
  const { classes } = styles();
  return (
    <AppLayout>
      <Box className={`${classes.container}`}>
        <Header />
        <Box className={`${classes.inputContact} `}>
          <Box>
            <InputForm />
          </Box>
          <Box>
            <SocialContact />
          </Box>
        </Box>

        <Next />
      </Box>
    </AppLayout>
  );
}
const styles = makeStyles()((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(3),
    minHeight: pxToRem(500),
  },
  debug: {
    border: "1px solid green",
  },
  inputContact: {
    display: "grid",
    gridTemplateColumns: "1.8fr 1fr",
    minHeight: pxToRem(600),
    padding: `${pxToRem(40)} ${pxToRem(AppSize.padding)}`,
    gap: pxToRem(40),
    alignSelf: "center",
    justifySelf: "center",
    [theme.breakpoints.down("sm")]: {
      display: "flex",
      flexDirection: "column",
      gap: theme.spacing(4),
      padding: `${theme.spacing(4)} ${pxToRem(20)}`,
    },
    [theme.breakpoints.down("md")]: {
      display: "flex",
      flexDirection: "column",
    },
  },
  map: {
    minHeight: pxToRem(500),
    position: "relative",
    padding: `20px ${pxToRem(AppSize.padding)}`,
    display: "flex",
    flexDirection: "column",
  },
  subMap: {
    flex: 1,
    position: "relative",
  },
}));
